import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { TaskService } from "../../task.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute } from "@angular/router";
import { PerfectScrollbarConfig } from "ngx-perfect-scrollbar";
import { PerfectScrollbarDirective } from "ngx-perfect-scrollbar";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-todo-list",
  templateUrl: "./todo-list.component.html",
  styleUrls: ["./todo-list.component.scss"]
})
export class TodoListComponent implements OnInit {
  @ViewChild(PerfectScrollbarDirective, { static: false }) perfectScrollbarDirectiveRef?: PerfectScrollbarDirective;

  public contentHeader: IContentHeader;
  public filter: string = "all";
  public tasks: any = null;
  public filtered_tasks: any = null;
  public filterText: string = "";
  public filterStatus: number;
  public filterPriority: number;
  public openedAddModal: boolean = false;
  public openedTask: number = 0;
  public config: any = PerfectScrollbarConfig;

  private checkedTasks: boolean = false;

  constructor(
    public _taskService: TaskService,
    public _utilsService: UtilsService,
    private _activatedRoute: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    this._utilsService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: "MENU.MY_TASK_LIST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.MY_TASK_LIST",
            isLink: false
          }
        ]
      }
    };

    this._activatedRoute.queryParams.subscribe((params) => {
      if (params.task) {
        this.openedTask = Number(params.task);
      }
    });
  }

  async ngOnInit() {
    this.refreshData();
  }

  async afterAddedTask() {
    try {
      this._utilsService.showLoading()
      this.openedAddModal = false;
      this._taskService.getMine().then((tasks: any) => {
        this.tasks = tasks;
        this.filterTask();
        this._utilsService.hideLoading();
      });
    } catch (e) {
      console.error(e)
    }
  }

  refreshData() {
    this.openedAddModal = false;

    if (!this.checkedTasks && this._taskService.mine.length < 1) {
      this.checkedTasks = true;
      this._taskService.getMine().then((tasks: any) => {
        this.tasks = tasks;
        this.filterTask();
        this._utilsService.hideLoading();
      });
    } else {
      this.tasks = this._taskService.mine;
      this.filterTask();
      this._utilsService.hideLoading();
    }
  }

  filterTask() {
    this.perfectScrollbarDirectiveRef?.scrollToTop(0, 1); //Resetto lo scroll a zero
    if (this.tasks && this.tasks.length > 0) {
      this.filtered_tasks = JSON.parse(JSON.stringify(this.tasks));

      if (this.filter === "i_assigned") {
        this.filtered_tasks = this.filtered_tasks.filter((task: any) => task.view_because === "have_assigned");
      } else {
        this.filtered_tasks = this.filtered_tasks.filter((task: any) => task.view_because === "assigned_to_me");
      }

      if (this.filterStatus !== undefined && this.filterStatus !== null) {
        this.filtered_tasks = this.filtered_tasks.filter((task: any) => task.status === this.filterStatus);
      } else {
        this.filtered_tasks = this.filtered_tasks.filter((r: any) => Number(r.status) !== 2);
      }

      if (this.filterPriority !== undefined && this.filterPriority !== null) {
        this.filtered_tasks = this.filtered_tasks.filter((task: any) => task.priority === this.filterPriority);
      }

      if (this.filterText.length > 0) {
        const key: string = String(this.filterText).toLowerCase().trim();
        this.filtered_tasks = this.filtered_tasks.filter((r: any) => r.title.toLowerCase().includes(key));
      }
    }

    this._utilsService.hideLoading();
  }

  onCloseDetailModal() {
    setTimeout(() => {
      this.openedTask = 0;
      this.checkedTasks = false;
      this.refreshData();
    }, 300);
  }

  openTask(id: number) {
    this.openedTask = id;
  }

  async setCompleted(task: any) {
    try {
      this._utilsService.showLoading();
      await this._taskService.setCompleted(task.id);
      task.status = 2;
      this.checkedTasks = false;
      this._taskService.mine = [];
      this.refreshData();
      this._changeDetectorRef.detectChanges();
      await this._utilsService.showSWALSuccess({ text: "SUCCESS_TASK_SET_AS_COMPLETED" });
    } catch (e: any) {
      await this._utilsService.showSWALError({ text: "ERROR_TASK_SET_STATUS" });
    }
  }
}
